import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBxedE7EUIBpfHpM6pstCNL2I7EtmJXo0U",
  authDomain: "epcore2025.firebaseapp.com",
  projectId: "epcore2025",
  storageBucket: "epcore2025.firebasestorage.app",
  messagingSenderId: "382248620722",
  appId: "1:382248620722:web:3d5f5cc984795ac5b86fab"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Exportar servicios
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;